import { render, staticRenderFns } from "./AssignSalesPerson.vue?vue&type=template&id=fe4058b8&scoped=true&"
import script from "./AssignSalesPerson.vue?vue&type=script&lang=js&"
export * from "./AssignSalesPerson.vue?vue&type=script&lang=js&"
import style0 from "./AssignSalesPerson.vue?vue&type=style&index=0&id=fe4058b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4058b8",
  null
  
)

export default component.exports